import { IRequestClient } from "@modules/request/types/instance";

export class UserRepository {
  public readonly abortControllers = {
    authUser: new AbortController(),
  };

  public constructor(private requestClient: IRequestClient) {}

  public authUser = async (user: {
    username: string;
    password: string;
  }): Promise<any> => {
    if (this.abortControllers.authUser) {
      this.abortControllers.authUser.abort();
    }

    this.abortControllers.authUser = new AbortController();

    return await this.requestClient.post("auth/login", user, {
      signal: this.abortControllers.authUser.signal,
    });
  };

  public beforeDestroy = (): void => {
    Object.values(this.abortControllers).forEach((abortController) =>
      abortController.abort()
    );
  };
}
